import React from 'react'
import URLS from '../config/URLS'
import Menu from './Menu'
import { Outlet } from 'react-router'
import { Container, Link } from '@abw/badger-ui'

const AboutLayout = () =>
  <Container>
    <div className="sidebar">
      <aside>
        <Menu>
          <Link to={URLS.about.home}    text="About us"/>
          <Link to={URLS.about.guide}   text="Guide to hiring"/>
          <Link to={URLS.about.faq}     text="Frequently asked questions"/>
          <Link to={URLS.about.contact} text="Contact us"/>
          <Link to={URLS.about.terms}   text="Terms and conditions"/>
          <Link to={URLS.about.privacy} text="Privacy policy"/>
          <Link to={URLS.about.legal}   text="Legal stuff"/>
          <Link to={URLS.about.collect} text="Collecting equipment"/>
          <Link to={URLS.about.return}  text="Returning equipment"/>
        </Menu>
      </aside>
      <main>
        <Outlet/>
      </main>
    </div>
  </Container>

export default AboutLayout